type ColumnsIconProps = {
  color?: string;
  size?: string
}

export const ColumnsIcon = ({ color = '#363BC4', size }: ColumnsIconProps): JSX.Element => (
  <svg width={size ?? '14'} height={size ?? '15'} viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.25 2.25V12.75M8.75 2.25V12.75M4.55 2.25H9.45C10.4301 2.25 10.9201 2.25 11.2945 2.44074C11.6238 2.60852 11.8915 2.87623 12.0593 3.20552C12.25 3.57986 12.25 4.06991 12.25 5.05V9.95C12.25 10.9301 12.25 11.4201 12.0593 11.7945C11.8915 12.1238 11.6238 12.3915 11.2945 12.5593C10.9201 12.75 10.4301 12.75 9.45 12.75H4.55C3.56991 12.75 3.07986 12.75 2.70552 12.5593C2.37623 12.3915 2.10852 12.1238 1.94074 11.7945C1.75 11.4201 1.75 10.9301 1.75 9.95V5.05C1.75 4.06991 1.75 3.57986 1.94074 3.20552C2.10852 2.87623 2.37623 2.60852 2.70552 2.44074C3.07986 2.25 3.56991 2.25 4.55 2.25Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
